interface Props {
  activeColor: string;
  bgColor?: string;
}

const SystemErrorIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor ? activeColor : "#2E8B57";
  const bgFillColor = bgColor ? bgColor : "#fce7f3";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <path
        d="M24 14 L34 32 H14 Z"
        stroke="#9d174d"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />

      <line
        x1="24"
        y1="20"
        x2="24"
        y2="27"
        stroke="#9d174d"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      <circle cx="24" cy="30" r="1.5" fill="#9d174d" />
    </svg>
  );
};

export default SystemErrorIcon;
